import ClientLike from "../client-like";
import ProjectCompany from "@/models/project-company";

export default class ProjectCompanyApi {
  public constructor(private client: ClientLike) {}

  public async all(
    projectId: number,
    options: { taskTypeIds?: string[]; favorite?: string } = {}
  ): Promise<ProjectCompany[]> {
    const data = await this.client.get("get_project_worker_companies.php", {
      projectId,
      ...options
    });
    return data.companyList.map(
      (c: any) => new ProjectCompany(c.companyId, c.name)
    );
  }
}
